import { render, staticRenderFns } from "./spaceTime.vue?vue&type=template&id=16381dcc&scoped=true&"
import script from "./spaceTime.vue?vue&type=script&lang=js&"
export * from "./spaceTime.vue?vue&type=script&lang=js&"
import style0 from "./spaceTime.vue?vue&type=style&index=0&id=16381dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16381dcc",
  null
  
)

export default component.exports